
import React from 'react'
import styled from 'styled-components'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { sidebarItemsData } from '../Data/SidebarData'
import { allChannelsData } from '../Data/ChannelData'
import AddIcon from '@material-ui/icons/Add';
import db from '../firebase'
import { useHistory } from 'react-router-dom'

function Sidebar(props) {
   
    const history = useHistory();

    const goToChannel = (id) => {
        if(id){
           history.push(`/room/${id}`)
        }
    }

    const addChannel = () => {
        const promptName = prompt("Enter Channel Name")
        
        if(promptName){

            db.collection('rooms').add({
                name: promptName
            })
        }
    }
    return (
       
            <Container>
                <WorkspaceContainer>
                    <Name>
                        Ansh Dalwadi
                    </Name>
                    <NewMessage>
                        <AddCircleOutlineIcon/>

                    </NewMessage>
                </WorkspaceContainer>

                <MainChannels>
                    {
                        sidebarItemsData.map(item => (

                            <MainChannelItem>
                             {item.icon}
                             {item.text}
                            </MainChannelItem>

                        ))
                    }
                   
                </MainChannels>
                <ChannelsContainer>
                    <NewChannelContainer>
                        <div>
                            Channels
                        </div>
                        <AddIcon onClick = {addChannel} />
                    </NewChannelContainer>

                    <ChannelsList>
                        
                         {
                           props.rooms.map(item => (
                            <Channel onClick={() => goToChannel(item.id)}>
                              # {item.name}
                            </Channel>
                         ))
                         }
                       
                        
                    </ChannelsList>
                    
                </ChannelsContainer>
            </Container>
      
    )
}

export default Sidebar

const Container = styled.div
`
background-image: linear-gradient(#FD297A , #9424F0);

`
const WorkspaceContainer = styled.div
`
color: #0D0D0D;
font-weight:bold;
height:64px;
font-size:18px;
display:flex;
align-items:center;
padding-left:19px;
justify-content: space-between;
border-bottom: 1px solid #532753;

`
const Name = styled.div
`

`
const NewMessage = styled.div
`
width:36px;
height:36px;
border-radius:50%;
background:white;
color:#3F0E40;
fill: #3F0E40;
display:flex;
justify-content: center;
align-items:center;
margin-right:20px;
cursor:pointer;
`

const MainChannels = styled.div
`
Padding-top: 20px;
`
const MainChannelItem = styled.div
`
color: #0D0D0D;
display: grid;
grid-template-columns: 15% auto;
height:28px;
align-items:center;
padding-left:40px;
cursor:pointer;
:hover{
    background: #9424F0;
}
`

const ChannelsContainer = styled.div
`
color: #0D0D0D;
margin-top:20px;
font-size: 17px;
font-weight: bold;
`

const NewChannelContainer = styled.div
`

display: flex;
justify-content: space-between;
align-items:center;
height:28px;
padding-left:19px;
padding-right:12px;


`

const ChannelsList = styled.div
`

`
const Channel = styled.div
`
height: 28px;
display: flex;
align-items:center;
padding-left: 19px;
cursor: pointer;
:hover{
    background: #9424F0;
}

`